import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Pronostics = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Pronostics Sportifs</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-8 space-y-8">
          <section>
            <p className="text-gray-700 text-lg leading-relaxed">
              Découvrez nos conseils pour réaliser des <strong>pronostics sportifs</strong> pertinents 
              et améliorer vos analyses avant de placer vos paris.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Comment faire un bon pronostic ?</h2>
            
            <div className="space-y-4">
              <div className="flex items-start space-x-4">
                <div className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0">1</div>
                <div>
                  <h3 className="font-semibold text-gray-900">Analysez les statistiques</h3>
                  <p className="text-gray-600 mt-1">
                    Forme récente des équipes, confrontations directes, statistiques à domicile/extérieur, 
                    nombre de buts marqués/encaissés.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0">2</div>
                <div>
                  <h3 className="font-semibold text-gray-900">Suivez l'actualité sportive</h3>
                  <p className="text-gray-600 mt-1">
                    Blessures, suspensions, contexte du match (derby, finale, maintien), 
                    déclarations des entraîneurs, motivation des équipes.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0">3</div>
                <div>
                  <h3 className="font-semibold text-gray-900">Évaluez les cotes</h3>
                  <p className="text-gray-600 mt-1">
                    Comparez les cotes des différents bookmakers. Une cote qui semble trop haute 
                    ou trop basse peut révéler une opportunité ou un piège.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0">4</div>
                <div>
                  <h3 className="font-semibold text-gray-900">Restez objectif</h3>
                  <p className="text-gray-600 mt-1">
                    Ne laissez pas vos préférences personnelles influencer vos pronostics. 
                    L'analyse doit être basée sur des faits, pas sur des émotions.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Sports les plus pronostiqués</h2>
            
            <div className="grid md:grid-cols-3 gap-4">
              <div className="bg-green-50 rounded-lg p-4 text-center">
                <span className="text-3xl">⚽</span>
                <h3 className="font-semibold text-gray-900 mt-2">Football</h3>
                <p className="text-gray-600 text-sm mt-1">
                  Ligue 1, Premier League, Liga, Serie A, Champions League
                </p>
              </div>
              
              <div className="bg-orange-50 rounded-lg p-4 text-center">
                <span className="text-3xl">🏀</span>
                <h3 className="font-semibold text-gray-900 mt-2">Basketball</h3>
                <p className="text-gray-600 text-sm mt-1">
                  NBA, Euroleague, Betclic Élite
                </p>
              </div>
              
              <div className="bg-yellow-50 rounded-lg p-4 text-center">
                <span className="text-3xl">🎾</span>
                <h3 className="font-semibold text-gray-900 mt-2">Tennis</h3>
                <p className="text-gray-600 text-sm mt-1">
                  Grand Chelem, ATP, WTA
                </p>
              </div>
              
              <div className="bg-blue-50 rounded-lg p-4 text-center">
                <span className="text-3xl">🏈</span>
                <h3 className="font-semibold text-gray-900 mt-2">Rugby</h3>
                <p className="text-gray-600 text-sm mt-1">
                  Top 14, Six Nations, Coupe du Monde
                </p>
              </div>
              
              <div className="bg-purple-50 rounded-lg p-4 text-center">
                <span className="text-3xl">🏇</span>
                <h3 className="font-semibold text-gray-900 mt-2">Hippisme</h3>
                <p className="text-gray-600 text-sm mt-1">
                  Courses PMU, Prix de l'Arc de Triomphe
                </p>
              </div>
              
              <div className="bg-red-50 rounded-lg p-4 text-center">
                <span className="text-3xl">🥊</span>
                <h3 className="font-semibold text-gray-900 mt-2">MMA / Boxe</h3>
                <p className="text-gray-600 text-sm mt-1">
                  UFC, Boxe professionnelle
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Outils pour vos pronostics</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Sites de statistiques :</strong> SofaScore, Flashscore, WhoScored</li>
              <li><strong>Actualité sportive :</strong> L'Équipe, RMC Sport, Eurosport</li>
              <li><strong>Comparateurs de cotes :</strong> Pour trouver les meilleures valeurs</li>
              <li><strong>Forums de parieurs :</strong> Échangez avec d'autres passionnés</li>
            </ul>
          </section>

          <section className="bg-amber-50 border border-amber-200 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-amber-800 mb-3">Attention aux vendeurs de pronostics</h2>
            <p className="text-amber-700">
              Méfiez-vous des services payants promettant des gains garantis. Aucun pronostiqueur 
              ne peut garantir des gains sur le long terme. Les paris sportifs comportent toujours 
              une part d'incertitude. Faites vos propres analyses et ne pariez que ce que vous 
              pouvez vous permettre de perdre.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Pronostics;
